import { styled } from "@mui/material";

import { ButtonNewest } from "@acre/design-system";

export const ReferralButton = styled(ButtonNewest)(({ theme }) => ({
    width: '100%',
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(2.5),
    background: theme.colours.new.violet2,
    ':hover:not(:disabled)': { background: theme.colours.new.blue5 },
    ':active:not(:disabled)': { background: theme.colours.new.indigo5 },
    ':disabled': {
        background: theme.colours.new.violet2,
        opacity: 0.3
    }
}))
